import { render } from "./About.vue?vue&type=template&id=1879f2d7&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1879f2d7"

export default script